// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","title":"Header_title__l+wMf","subtitle":"Header_subtitle__KVA1a"};